import { render } from "./Book.vue?vue&type=template&id=bccc1a3a&scoped=true"
import script from "./Book.vue?vue&type=script&lang=js"
export * from "./Book.vue?vue&type=script&lang=js"

import "./Book.vue?vue&type=style&index=0&id=bccc1a3a&lang=less&scoped=true"

import exportComponent from "E:\\heguang\\hotel\\src\\manage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bccc1a3a"]])

export default __exports__